export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
}